export const CHECKLIST_SHOW_DETAILS = 'CHECKLIST_SHOW_DETAILS';
